import { render } from "./Main.vue?vue&type=template&id=379ac0eb&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=379ac0eb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-379ac0eb"

export default script